<template>
  <div class="add-account-overlay" v-if="visible" @click.self="$emit('close')">
    <div class="add-account-popup">
      <div class="add-account-card">
        <div class="add-account-title">添加三方钱包</div>

        <div class="add-account-input-wrap">
          <img class="add-account-input-icon" src="/static/newImg/bank/icon/icon_zsxm1.svg" />
          <input
            class="add-account-input"
            v-model="walletName"
            type="text"
            placeholder="请填写真实姓名"
          />
          <span class="add-account-paste" @click="onPaste('walletName')">粘贴</span>
        </div>

        <div class="add-account-select-wrap" @click.stop="showWalletDropdown = !showWalletDropdown">
          <img class="add-account-icon" src="/static/newImg/bank/icon/icon_bzbh.svg" />
          <span class="add-account-select-text" :class="{ active: selectedWallet }">
            <img v-if="selectedWallet" :src="$imgUrl(selectedWallet.icon)" class="add-account-select-icon" />
            {{ selectedWallet ? selectedWallet.name : '请选择钱包' }}
          </span>
          <svg class="add-account-select-arrow" :class="{ open: showWalletDropdown }" viewBox="0 0 24 24" width="18" height="18">
            <path d="M6 9l6 6 6-6" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <div class="add-account-select-dropdown" v-if="showWalletDropdown" @click.stop>
            <div
              class="add-account-select-option"
              v-for="item in walletList"
              :key="item.id"
              :class="{ active: selectedWallet && selectedWallet.id === item.id }"
              @click.stop="selectWallet(item)"
            >
              <img :src="$imgUrl(item.icon)" class="add-account-select-icon" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>

        <div class="add-account-input-wrap">
          <input
            class="add-account-input"
            v-model="walletAccount"
            type="text"
            placeholder="请输入钱包地址"
          />
          <span class="add-account-paste" @click="onPaste('walletAccount')">粘贴</span>
        </div>

        <div class="add-account-tip">
          请认真核对，否则将无法到账。
        </div>

        <div class="add-account-confirm" :class="{ disabled: submitting }" @click="onConfirm">
          {{ submitting ? '提交中...' : '确定' }}
        </div>
      </div>

      <div class="add-account-close" @click="$emit('close')">
        <svg viewBox="0 0 24 24" width="32" height="32">
          <circle cx="12" cy="12" r="10" fill="none" stroke="#fff" stroke-width="1.5"/>
          <line x1="8" y1="8" x2="16" y2="16" stroke="#fff" stroke-width="1.5"/>
          <line x1="16" y1="8" x2="8" y2="16" stroke="#fff" stroke-width="1.5"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddThirdPopup',
  props: {
    visible: { type: Boolean, default: false },
    password: { type: String, default: '' },
  },
  data() {
    return {
      selectedWallet: null,
      walletList: [],
      showWalletDropdown: false,
      walletAccount: '',
      walletName: '',
      submitting: false,
    };
  },
  mounted() {
    this.loadWalletList();
  },
  watch: {
    visible(val) {
      if (val) {
        this.walletAccount = '';
        this.walletName = '';
        this.selectedWallet = null;
        this.showWalletDropdown = false;
        this.submitting = false;
        this.loadWalletList();
      }
    },
  },
  methods: {
    // 统一 toast：向上级联找 App.vue 的 showTost(type, msg)，不会被当前弹框遮罩挡住
    toast(msg, type = 0) {
      let p = this.$parent;
      while (p) {
        if (typeof p.showTost === 'function') {
          p.showTost(type, msg);
          return;
        }
        p = p.$parent;
      }
      if (this.$notify) {
        this.$notify({ type: type ? 'success' : 'danger', message: msg, zIndex: 999999, duration: 2500 });
        return;
      }
      if (this.$toast) {
        try { this.$toast({ message: msg, zIndex: 999999, position: 'top' }); } catch (_) { this.$toast(msg); }
        return;
      }
      this._domToast(msg);
    },
    _domToast(msg) {
      try {
        if (!msg) return;
        const el = document.createElement('div');
        el.textContent = msg;
        Object.assign(el.style, {
          position: 'fixed', top: '40%', left: '50%', transform: 'translateX(-50%)',
          background: 'rgba(0,0,0,0.78)', color: '#fff', padding: '0.24rem 0.35rem',
          borderRadius: '0.1rem', fontSize: '0.3rem', zIndex: '999999',
          maxWidth: '80%', textAlign: 'center', pointerEvents: 'none',
        });
        document.body.appendChild(el);
        setTimeout(() => { try { document.body.removeChild(el); } catch (_) {} }, 1500);
      } catch (_) {}
    },
    loadWalletList() {
      this.$apiFun.post('/api/paymentCategories', { type: 3 }).then((res) => {
        if (res.code === 200 && res.data) {
          if (res.data.thirdList) {
            this.walletList = res.data.thirdList;
          } else if (Array.isArray(res.data.list)) {
            this.walletList = res.data.list.filter((item) => item.type === 3);
          } else if (Array.isArray(res.data)) {
            this.walletList = res.data.filter((item) => item.type === 3);
          }
        }
      }).catch(() => {});
    },
    selectWallet(item) {
      this.selectedWallet = item;
      this.showWalletDropdown = false;
    },
    onPaste(field) {
      if (navigator.clipboard && navigator.clipboard.readText) {
        navigator.clipboard.readText().then((text) => {
          if (text) {
            this[field] = text;
          }
        }).catch(() => {
          this.toast('请手动粘贴');
        });
      } else {
        this.toast('请手动粘贴');
      }
    },
    onConfirm() {
      if (this.submitting) return;
      if (!this.selectedWallet) {
        this.toast('请选择钱包');
        return;
      }
      if (!this.walletName.trim()) {
        this.toast('请填写真实姓名');
        return;
      }
      if (!this.walletAccount.trim()) {
        this.toast('请输入钱包地址');
        return;
      }
      const needReauth = (msg) => /提现密码/.test(msg || '');
      this.submitting = true;
      const that = this;
      this.$apiFun
        .post('/api/userCards/add', {
          type: 3,
          wallet_type_id: this.selectedWallet.id,
          wallet_account: this.walletAccount.trim(),
          wallet_owner: this.walletName.trim(),
          password: this.password,
        })
        .then((res) => {
          that.submitting = false;
          if (res.code === 200) {
            that.toast('提交成功', 1);
            that.$emit('added');
            that.$emit('close');
          } else {
            const msg = res.message || res.msg || '提交失败';
            that.toast(msg);
            if (needReauth(msg)) {
              that.$emit('close');
              that.$emit('needReauth');
            }
          }
        })
        .catch(() => {
          that.submitting = false;
          that.toast('网络异常，请稍后重试');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-account-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-account-popup {
  width: 92%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.add-account-card {
  width: 92%;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 0.2rem;
  padding: 0.4rem 0.35rem;
}

.add-account-title {
  text-align: center;
  font-size: 0.38rem;
  color: #fff;
  font-weight: bold;
  margin-bottom: 0.35rem;
}

.add-account-select-wrap {
  display: flex;
  align-items: center;
  background: rgb(0 0 0 / 5%);
  border: 1px solid #666;
  border-radius: 0.1rem;
  padding: 0.2rem 0.25rem;
  margin-bottom: 0.2rem;
  cursor: pointer;
  position: relative;
}

.add-account-icon {
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.15rem;
}

.add-account-input-icon {
  width: 0.45rem;
  height: 0.45rem;
  margin-right: 0.15rem;
}

.add-account-select-text {
  flex: 1;
  font-size: 0.3rem;
  color: #666;
  display: flex;
  align-items: center;
  gap: 0.1rem;

  &.active {
    color: #fff;
  }
}

.add-account-select-icon {
  width: 0.5rem;
  height: 0.5rem;
  object-fit: contain;
  flex-shrink: 0;
}

.add-account-select-arrow {
  transition: transform 0.2s;

  &.open {
    transform: rotate(180deg);
  }
}

.add-account-select-dropdown {
  position: absolute;
  top: calc(100% + 0.05rem);
  left: 0;
  right: 0;
  z-index: 10;
  background: #000;
  border: 1px solid #333;
  border-radius: 0.1rem;
  max-height: 8rem;
  overflow-y: auto;
}

.add-account-select-option {
  padding: 0.2rem 0.25rem;
  font-size: 0.3rem;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.1rem;

  &.active {
    color: #fff;
  }
}

.add-account-input-wrap {
  display: flex;
  align-items: center;
  background: rgb(0 0 0 / 5%);
  border: 1px solid #666;
  border-radius: 0.1rem;
  padding: 0 0.25rem 0 0.25rem;
  margin-bottom: 0.2rem;
}

.add-account-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 0.3rem;
  padding: 0.1rem 0;
  height: 0.9rem;

  &::placeholder {
    color: #666;
  }
}

.add-account-paste {
  color: #d1ae52;
  font-size: 0.28rem;
  cursor: pointer;
  padding-left: 0.15rem;
}

.add-account-tip {
  font-size: 0.28rem;
  color: #d1ae52;
  margin: 0.25rem 0;
  line-height: 1.4;
}

.add-account-confirm {
  width: 100%;
  background: #d1ae52;
  color: #703904;
  text-align: center;
  font-size: 0.35rem;
  padding: 0.25rem 0;
  border-radius: 0.1rem;
  cursor: pointer;
  margin-top: 0.3rem;
  letter-spacing: 0.15rem;
}

.add-account-close {
  margin-top: 0.5rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/view/withdraw/AddThirdPopup.vue